import { TableId } from '@/types/table';
import { PLAYER_ID, TEAM_ID } from '../searchKeys';

// This is used in a couple of bits of logic to determine whether a cell
// should be clickable
export const MINUTES_PLAYED_COLUMN = 'aggregates.minutesPlayed';

export const AGGS_TABLE_CONFIG = {
  player: {
    param: PLAYER_ID,
    entityKey: 'player.playerId',
  },
  team: {
    param: TEAM_ID,
    entityKey: 'team.teamId',
  },
};

// Single source of truth for the entity column that is pinned to the left
// on each table. Absence from this map means the table has no locked column.
export const LOCKED_COLUMN_BY_TABLE_ID: Partial<Record<TableId, string>> = {
  [TableId.PLAYER_AGGS]: 'playerLink',
  [TableId.TEAM_AGGS]: 'teamLink',
  [TableId.TEAM_SQUAD]: 'playerLink',
  [TableId.TEAM_GAMES]: 'game.name',
  [TableId.PLAYER_GAMES_GK]: 'game.name',
  [TableId.PLAYER_GAMES_OUTFIELD]: 'game.name',
};

// Width (rem) used for the row-selection checkbox column when it is included as a sticky column.
// Kitbag needs a real width on every sticky column except the rightmost so the next column's
// leftOffset positions correctly. The value approximates the rendered checkbox cell width
// (checkbox + horizontal padding) — verify visually if the rendered checkbox cell changes size.
export const SELECTION_COLUMN_STICKY_WIDTH_REM = 3;
